import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import List from "./List";
import api from "./api/api";
import CustomerForm from "./CustomerForm";
import CustomerCreditPopup from "./CustomerCreditPopup";
import CustomerFidelityPopup from "./CustomerFidelityPopup";
import EditIcon from "../icons/EditIcon";
import SearchIcon from "../icons/SearchIcon";
import StarIcon from "../icons/StarIcon";
import functions from "../functions/functions";

function CreditCardIcon() {
	return (
		<svg viewBox="0 0 16 16" fill="currentColor" width="13" height="13" aria-hidden="true">
			<path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1H0V4zm0 3h16v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7zm3 2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H3z"/>
		</svg>
	);
}

// stessi valori dell'API (pos2::CUSTOMERS_SEARCH_MIN_LENGTH / CUSTOMERS_SEARCH_LIMIT)
const MIN_SEARCH_LENGTH = 2;
const SEARCH_RESULTS_LIMIT = 50;

function CustomersPopUp() {
	const {
		setPopup,
		editCart2,
		selectCustomer,
		setConfirm,
		cart,
		shop,
		setAddressFormPopUpVisible,
		searchAddressTerm,
		setSearchAddressTerm,
		setLoading,
		searchTerm,
		setSearchTerm,
		apiSettings,
		updateCartCustomerBalance,
	} = useContext(AppContext);
	const [customers, setCustomers] = useState([]);
	const [addresses, setAddresses] = useState([]);
	const [tempName, setTempName] = useState("");
	const [tempSurname, setTempSurname] = useState("");
	const [localPopup, setLocalPopup] = useState(null);
	const isDeliveryFlow = cart.delivery_type.id == "delivery";
	const activeSearchTerm = isDeliveryFlow ? searchAddressTerm : searchTerm;
	const hasSearch = activeSearchTerm.trim().length > 0;
	const searchTooShort = hasSearch && activeSearchTerm.trim().length < MIN_SEARCH_LENGTH;
	const hasResults = customers.length + addresses.length > 0;
	const resultsLimited = customers.length >= SEARCH_RESULTS_LIMIT || addresses.length >= SEARCH_RESULTS_LIMIT;

	useEffect(() => {
		const delayDebounceFn = setTimeout(async () => {
			console.log(searchTerm);
			if (!searchTerm || searchTerm.trim().length < MIN_SEARCH_LENGTH) {
				setCustomers([]);
				setLoading(false);
				return false;
			}
			const res = await api.postProtected("/pos2/customers/", {
				search: searchTerm,
			});
			setLoading(false);
			setCustomers(res.rows);
		}, 1000);

		return () => clearTimeout(delayDebounceFn);
	}, [searchTerm]);

	useEffect(() => {
		const delayDebounceFn = setTimeout(async () => {
			console.log(searchAddressTerm);
			if (!searchAddressTerm || searchAddressTerm.trim().length < MIN_SEARCH_LENGTH) {
				setAddresses([]);
				setLoading(false);
				return false;
			}
			const res = await api.postProtected("/pos2/customers_addresses/", {
				shop_id: shop.id,
				search: searchAddressTerm,
			});
			setLoading(false);
			setAddresses(res.rows);
		}, 1000);

		return () => clearTimeout(delayDebounceFn);
	}, [searchAddressTerm]);

	const saveTemporaryCustomer = () => {
		const name = tempName.trim();
		const surname = tempSurname.trim();
		if (!name || !surname) {
			setConfirm({
				title: "Errore",
				message: "Inserire nome e cognome per il cliente temporaneo",
			});
			return;
		}

		editCart2({
			customer: null,
			name: name,
			surname: surname,
			area_code: null,
			mobile: null,
			email: null,
			address: null,
			delivery_date: false,
		});
		setSearchTerm("");
		setSearchAddressTerm("");
		setPopup(false);
	};

	const refreshCustomers = async () => {
		if (!searchTerm || searchTerm.trim().length < MIN_SEARCH_LENGTH) return;
		const res = await api.postProtected("/pos2/customers/", { search: searchTerm });
		if (res?.rows) setCustomers(res.rows);
	};

	const handleAfterTransaction = async () => {
		await refreshCustomers();
		updateCartCustomerBalance();
	};

	const clearSearch = () => {
		if (isDeliveryFlow) setSearchAddressTerm("");
		else setSearchTerm("");
	};

	return (
		<div className={`customer-flow-popup ${hasSearch ? "with-results" : ""}`}>
		{localPopup && (
			<div className="customer-local-overlay" onClick={(e) => { if (e.target === e.currentTarget) setLocalPopup(null); }}>
				<div className="customer-local-modal">
					<div className="customer-local-modal-header">
						<div className="customer-local-modal-title">{localPopup.title}</div>
						<button className="customer-local-modal-close" onClick={() => setLocalPopup(null)}>&times;</button>
					</div>
					<div className="customer-local-modal-body">{localPopup.content}</div>
				</div>
			</div>
		)}
			<div className="customer-flow-options">
				<div className="customer-flow-option-card">
					<div className="customer-flow-option-title customer-flow-option-title-center">
						{isDeliveryFlow ? "Cerca cliente o indirizzo" : "Cerca cliente"}
					</div>
					<div className="customer-flow-search-card">
						{isDeliveryFlow && (
							<div className="customer-flow-search-fields">
								<div className="customer-flow-search-input-wrap">
									<input
										type="text"
										placeholder="Cerca cliente"
										autoFocus
										value={searchAddressTerm}
										onChange={(e) => setSearchAddressTerm(e.target.value)}
									/>
									<div className="customer-flow-search-actions">
										{activeSearchTerm ? (
											<button
												type="button"
												className="customer-flow-search-clear"
												onClick={clearSearch}
												aria-label="Pulisci ricerca"
											>
												&times;
											</button>
										) : null}
										<span className="customer-flow-search-icon" aria-hidden="true">
											<SearchIcon />
										</span>
									</div>
								</div>
							</div>
						)}
						{!isDeliveryFlow && (
							<div className="customer-flow-search-fields">
								<div className="customer-flow-search-input-wrap">
									<input
										type="text"
										placeholder="Cerca cliente"
										autoFocus
										value={searchTerm}
										onChange={(e) => setSearchTerm(e.target.value)}
									/>
									<div className="customer-flow-search-actions">
										{activeSearchTerm ? (
											<button
												type="button"
												className="customer-flow-search-clear"
												onClick={clearSearch}
												aria-label="Pulisci ricerca"
											>
												&times;
											</button>
										) : null}
										<span className="customer-flow-search-icon" aria-hidden="true">
											<SearchIcon />
										</span>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>

				<div className="customer-flow-option-card">
					<div className="customer-flow-option-title customer-flow-option-title-center">
						Inserisci cliente
					</div>
					<button
						className="button button-2 customer-flow-create-btn"
						onClick={() =>
							setPopup({
								title: "Inserisci cliente",
								content: <CustomerForm />,
								onClose: () =>
									setPopup({
										title: "Cliente",
										content: <CustomersPopUp />,
									}),
							})
						}
					>
						Crea nuovo Cliente
					</button>
				</div>
			</div>
			{hasSearch && (
				<div className="customer-flow-results">
					<div className="customer-flow-results-title">Risultati della ricerca</div>
					{searchTooShort && (
						<div className="customer-flow-results-empty">Inserisci almeno {MIN_SEARCH_LENGTH} caratteri</div>
					)}
					{!searchTooShort && !hasResults && <div className="customer-flow-results-empty">Nessun risultato trovato</div>}
					{resultsLimited && (
						<div className="customer-flow-results-empty">
							Mostrati i primi {SEARCH_RESULTS_LIMIT} risultati: affina la ricerca
						</div>
					)}
					<List
						className="customer-flow-list"
						elements={customers}
						customElement={(c, i) => (
							<div key={i} className="list-element group customer-flow-item">
								<div className="client-info">
									<div className="client-name">{c.surname + " " + c.name}</div>
									<div className="small">{c.area_code + c.mobile + " · " + c.email}</div>
									{(apiSettings.credit?.active == 1 || apiSettings.fidelity?.active == 1) && (
										<div className="small customer-flow-badges">
											{apiSettings.credit?.active == 1 && parseFloat(c.credit) > 0 && (
												<span className="customer-flow-credit-badge">
													{functions.formatter.format(parseFloat(c.credit))} credito
												</span>
											)}
											{apiSettings.fidelity?.active == 1 && parseInt(c.points) > 0 && (
												<span className="customer-flow-points-badge">
													{c.points} punti
												</span>
											)}
										</div>
									)}
								</div>
								<div className="buttons">
									{apiSettings.credit?.active == 1 && (
										<button
											className="customer-flow-credit-btn"
											onClick={() =>
												setLocalPopup({
													title: "Credito cliente",
													content: <CustomerCreditPopup customer={c} onClose={() => setLocalPopup(null)} onRefresh={handleAfterTransaction} />,
												})
											}
										>
											<CreditCardIcon /> Credito
										</button>
									)}
									{apiSettings.fidelity?.active == 1 && (
										<button
											className="customer-flow-fidelity-btn"
											onClick={() =>
												setLocalPopup({
													title: "Fidelity cliente",
													content: <CustomerFidelityPopup customer={c} onClose={() => setLocalPopup(null)} onRefresh={handleAfterTransaction} />,
												})
											}
										>
											<StarIcon width="12" height="12" /> Fidelity
										</button>
									)}
									<button
										onClick={() =>
											setPopup({
												title: "Modifica cliente",
												content: <CustomerForm customer={c} />,
											})
										}
									>
										Modifica
									</button>
									<button
										className="customer-flow-select-btn"
										onClick={(el) => {
											if (cart.delivery_type.id == "shop") {
												selectCustomer(c, { address: false });
											} else {
												selectCustomer(c, { address: false, delivery_date: false });
											}
											setPopup(false);
										}}
									>
										Seleziona
									</button>
								</div>
							</div>
						)}
					/>
					<List
						className="customer-flow-list"
						elements={addresses}
						customElement={(c, i) => (
							<div key={i} className="list-element customer-flow-address-item">
								<div className="group">
									<div>
										<div className="client-name">{c.surname + " " + c.name}</div>
										<div className="small">
											{c.area_code + c.mobile + " - " + c.email}
										</div>
									</div>
									<div className="buttons">
										<button
											onClick={() => {
												setPopup({
													title: "Modifica cliente",
													content: <CustomerForm customer={c} />,
												});
											}}
										>
											Modifica cliente
										</button>
										<button
											className="customer-flow-new-address-btn"
											onClick={() => {
												setPopup(false);
												selectCustomer(c);
												setAddressFormPopUpVisible(true);
											}}
										>
											Nuovo indirizzo
										</button>
									</div>
								</div>
								{c.addresses.map((address, n) => (
									<div key={n} className="subgroup customer-flow-address-subgroup">
										<button
											className="icon-button customer-flow-address-edit-left"
											onClick={() => {
												setPopup(false);
												setAddressFormPopUpVisible(address);
											}}
										>
											<EditIcon> </EditIcon>
										</button>
										<div className="customer-flow-address-details">
											<div className="customer-flow-address-line">
												{address.address + " " + address.number}
											</div>
											<div className="small">
												{address.zipcode +
													" " +
													address.city +
													" (" +
													address.province +
													")"}
											</div>
										</div>
										<div className="buttons">
											{address.covered == 1 && (
												<button
													className="customer-flow-covered-select-btn"
													onClick={() => {
														setPopup(false);
														selectCustomer(c, { address: address, delivery_date: false });
													}}
												>
													Seleziona
												</button>
											)}
											{address.covered == 0 && (
												<span className="customer-flow-uncovered-badge">Non coperto</span>
											)}
										</div>
									</div>
								))}
							</div>
						)}
					/>
				</div>
			)}
			{!isDeliveryFlow && (
				<div className="customer-flow-temp-dock">
					<div className="customer-flow-option-title">Cliente temporaneo</div>
					<div className="customer-flow-temp-helper">
						Inserisci nome e cognome del cliente per questo ordine - non viene salvato nella lista
						clienti
					</div>
					<div className="customer-flow-temp-row">
						<input
							type="text"
							placeholder="Nome"
							value={tempName}
							onChange={(e) => setTempName(e.target.value)}
						/>
						<input
							type="text"
							placeholder="Cognome"
							value={tempSurname}
							onChange={(e) => setTempSurname(e.target.value)}
						/>
						<button className="button button-2 customer-flow-temp-btn" onClick={saveTemporaryCustomer}>
							Salva
						</button>
					</div>
				</div>
			)}
		</div>
	);
}

export default CustomersPopUp;
